import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb, Loader, Nav, Panel, Stack } from 'rsuite';
import DiscoveryPointForm from './discovery-point-form';
import { BaseErrorModel, BaseResponseModel, PageState } from '@/models/core.model';
import { AxiosError } from 'axios';
import { toastErrorMessage } from '@/utils/toasterMessage';
import { DiscoveryPoint } from '@/models/discovery-point.model';
import { getDiscoveryPoint } from '@/services/discovery-point.service';
import DiscoveryPointActions from './discovert-point-actions';
import { City } from '@/models/city.model';
import { getCity } from '@/services/city.service';
import PageHeader from '@/components/PageHeader';

const CustomNav = ({ active, onSelect, newMode, formObject, ...props }) => {
  const nav = useNavigate();
  console.log(formObject);
  return (
    <Stack justifyContent={"space-between"}>
      <Nav {...props} activeKey={active} onSelect={onSelect}>
        <Nav.Item eventKey="discovery-point-form">Discovery Point Detail</Nav.Item>
        <Nav.Item disabled={newMode} eventKey="discovery-point-actions">Actions</Nav.Item>
      </Nav>
    </Stack>    
  );
};

const Page = () => {

  const requestedTab = useLocation()?.state?.tab;
  const cityId = useLocation()?.state?.cityId;

  const [activeTab, setActiveTab] = useState('discovery-point-form');
  const [formObject, setFormObject] = useState<DiscoveryPoint|undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState<City|undefined>(undefined);

  const nav = useNavigate();

  const { id: idParam } = useParams();
  const id = idParam ? parseInt(idParam, 10) : undefined;
  const pageState = id ? PageState.Edit : PageState.New;


  useEffect(() => {
    if (pageState == PageState.Edit) {
      fetchData();
    } else {
      setFormObject(undefined);
    }
    setActiveTab(pre => requestedTab ?? pre);
  }, [id]);

  useEffect(() => {
    if (formObject || cityId) {
      getCity(formObject?.cityId ?? cityId).then((result: BaseResponseModel<City>) => {
        if (result.success) {
          setCity(result.result);
        }
      }).catch((err) => {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching city: ${errorModel?.errorMessage}`);
      });
    }
  },[formObject, cityId]);

  const fetchData = async () => {
    if (id) {
      setLoading(true);
      try {
        const result: BaseResponseModel<DiscoveryPoint> = await getDiscoveryPoint(id);
        if (result.success) {
          setFormObject(result.result);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error in fetching Discovery Point: ${errorModel?.errorMessage}`);
        nav('/discovery-points');
      }
      finally {
        setLoading(false);
      }
    }
  };
 
  return (
    <Panel
      header={
        <PageHeader title={pageState == PageState.Edit && formObject ? `Edit Discovery Point: ${formObject.name}` : 'New Discovery Point'}>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href='/discovery-points'> Discovery Points</Breadcrumb.Item>
            <Breadcrumb.Item active>{pageState == PageState.Edit ? 'Edit' : 'New'}</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <CustomNav appearance="subtle" 
        active={activeTab} 
        onSelect={key => setActiveTab(key)} 
        newMode={pageState == PageState.New} 
        formObject={formObject}
      />
      {
        loading ? <Loader center content="loading ..." /> :
        <>
          {activeTab == 'discovery-point-form' && <DiscoveryPointForm formObject={formObject} city={city} pageState={pageState}/>}
          {activeTab == 'discovery-point-actions' && <DiscoveryPointActions formObject={formObject} city={city} fetchData={fetchData}/>}
        </>
      }
    </Panel>
  );
};

export default Page;
